
const $ = window.jQuery;

$(() => {
	$('.scroll-to-top').click(function(event) {
		event.preventDefault();
		$("html, body").animate({ scrollTop: 0 });
		return false;
	});
	
	$(document).on('click.bs.dropdown.data-api', '.yamm .dropdown-menu', e => {
		e.stopPropagation();
	});
});
